import { CoursesActionTypes } from './types';

const initialState = {
  courses: { data: [] },
  allCourses: [],
  loadingAllCourses: false,
  errorLoadingAllCourses: null,
  singleCourse: null,
  fecthingSingleCourse: false,
  filterOn: false,
  saveBulkUpload: false,
  downloadTemplate: false,
  loading: true,
  saving: null,
  errorSaving: null,
  error: null,
  status: null,
  current: null,
  applicants: { data: [] },
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case CoursesActionTypes.GET_ALL_COURSES:
      return {
        ...state,
        loadingAllCourses: true,
      };
    case CoursesActionTypes.GET_ALL_COURSES_SUCCESS:
      return {
        ...state,
        allCourses: payload,
        loadingAllCourses: false,
      };
    case CoursesActionTypes.GET_ALL_COURSES_FAILED:
      return {
        ...state,
        loadingAllCourses: false,
        errorLoadingAllCourses: payload,
      };
    case CoursesActionTypes.GET_COURSES:
      return {
        ...state,
        loading: true,
      };
    case CoursesActionTypes.GET_COURSE_DETAILS:
      return {
        ...state,
        fecthingSingleCourse: true,
      };
    case CoursesActionTypes.DELETE_COURSE:
      return {
        ...state,
        saving: true,
      };
    case CoursesActionTypes.SEARCH_COURSE:
      return {
        ...state,
      };
    case CoursesActionTypes.FILTER_BY_STATUS:
      return {
        ...state,
      };
    case CoursesActionTypes.BULK_COURSES_UPLOAD:
      return {
        ...state,
        saveBulkUpload: true,
      };
    case CoursesActionTypes.BULK_COURSES_UPLOAD_SUCCESS:
      return {
        ...state,
        saveBulkUpload: false,
      };
    case CoursesActionTypes.BULK_COURSES_UPLOAD_FAILURE:
      return {
        ...state,
        saveBulkUpload: false,
        error: payload,
      };
    case CoursesActionTypes.DOWNLOAD_COURSE_TEMPLATE:
      return {
        ...state,
        downloadTemplate: true,
      };
    case CoursesActionTypes.DOWNLOAD_COURSE_TEMPLATE_SUCCESS:
      return {
        ...state,
        downloadTemplate: false,
      };
    case CoursesActionTypes.DOWNLOAD_COURSE_TEMPLATE_FAILURE:
      return {
        ...state,
        downloadTemplate: false,
      };
    case CoursesActionTypes.FILTER_BY_ADMIN_LEVEL:
      return {
        ...state,
        loading: true,
      };
    case CoursesActionTypes.DELETE_COURSE_SUCCESS:
      return {
        ...state,
        saving: false,
        status: payload,
      };

    case CoursesActionTypes.GET_COURSES_SUCCESS:
      return {
        ...state,
        courses: payload,
        loading: false,
        filterOn: false,
      };
    case CoursesActionTypes.SEARCH_COURSE_RESULTS:
      return {
        ...state,
        courses: payload,
        loading: false,
        filterOn: true,
      };
    case CoursesActionTypes.GET_COURSES_APLLICANTS_SUCCESS:
      return {
        ...state,
        applicants: payload,
        loading: false,
      };
    case CoursesActionTypes.GET_COURSES_FAILED:
      return {
        ...state,
        loading: false,
      };
    case CoursesActionTypes.GET_COURSES_APLLICANTS_FAILED:
      return {
        ...state,
      };
    case CoursesActionTypes.GET_COURSE_DETAILS_FAILED:
      return {
        ...state,
        fecthingSingleCourse: false,
      };
    case CoursesActionTypes.DELETE_COURSE_FAILED:
      return {
        ...state,
        saving: false,
        error: payload,
      };
    case CoursesActionTypes.ADD_COURSE:
      return {
        ...state,
        saving: true,
        errorSaving: false,
      };
    case CoursesActionTypes.UPDATE_COURSE:
      return {
        ...state,
        saving: true,
        errorSaving: false,
      };
    case CoursesActionTypes.ADD_COURSE_SUCCESS:
      return {
        ...state,
        filterOn: false,
        courses: {
          ...state.courses,
          data: [{ ...payload, status: 'active' }, ...state.courses.data],
        },
        saving: false,
        errorSaving: false,
      };
    case CoursesActionTypes.ADD_COURSE_FAILED:
      return {
        ...state,
        saving: false,
        errorSaving: true,
      };
    case CoursesActionTypes.UPDATE_COURSE_FAILED:
      return {
        ...state,
        saving: false,
        errorSaving: true,
      };
    case CoursesActionTypes.UPDATE_COURSE_SUCCESS:
      return {
        ...state,
        courses: {
          ...state.courses,
          data: state.courses.data.map((course) =>
            course.id === payload.id ? { ...payload } : course
          ),
        },
        allCourses: state.allCourses.map((course) =>
                      course.id === payload.id ? { ...payload } : course
                    ),
        saving: false,
        errorSaving: false,
      };
    case CoursesActionTypes.ADD_FAILED:
      return {
        ...state,
        loading: false,
        error: payload,
      };
    case CoursesActionTypes.SET_CURRENT:
      return {
        ...state,
        current: payload,
      };
    case CoursesActionTypes.GET_COURSE_DETAILS_SUCCESS:
      return {
        ...state,
        current: payload,
        fecthingSingleCourse: false,
      };
    case CoursesActionTypes.CLEAR_CURRENT:
      return {
        ...state,
        current: null,
      };
    case CoursesActionTypes.CLEAR_STATUS:
      return {
        ...state,
        status: null,
      };
    case CoursesActionTypes.SET_STATUS:
      return {
        ...state,
        status: payload,
      };
    case CoursesActionTypes.CLEAR_ERROR:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
}
